"use client"
import React, { Component } from "react"
import { ChevronDown, ChevronRight } from "react-feather"
import { Button } from "@mui/material"
import Toast from "./Toast"
import API from "../services/API"
import redux from "../common/Redux"
import pdf from "../assets/pdf.png"
import csv from "../assets/csv.png"

const theme = {
  background: "#02111B",
  btnColor: "#FFC857",
  blackColor: "#07070A",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857",
  secondary: "#bb0a21",
  white: "#ffffff",
  drawerBgColor: "#041A29",
  pageBgColor: "#041A29",
  redColor: "#BB0A21",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  mutedWhite: "#9CA3AF",
  rootBgColor: "#041A29",
}

const ColorScheme = {
  buttonColor: "#FFC857",
  bgColor: "#02111B",
  componentColor: "#07070A",
  accentColor: "#BB0A21",
  textColor: "#FFFFFF",
}

class ReportTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      expandedRows: {},
      isLoading: false,
      search: "",
      page: props.currentPage || 1,
      perPageItem: props.currentPerPage || 10,
      totalItems: 0,
      totalPages: 0,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.api !== this.props.api) {
      this.fetchData()
    }

    if (prevProps.currentPage !== this.props.currentPage) {
      this.setState({ page: this.props.currentPage })
    }

    if (prevProps.currentPerPage !== this.props.currentPerPage) {
      this.setState({ perPageItem: this.props.currentPerPage })
    }
  }

  fetchData = async () => {
    this.setState({ isLoading: true })
    try {
      const response = await API(this, "get", this.props.api)

      console.log("=== DEBUGGING API RESPONSE ===")
      console.log("Full response:", response)
      console.log("Response status:", response.status)
      console.log("Response data:", response.data)

      if (response.status && response) {
        const responseData = response

        // Debug the exact structure
        console.log("responseData.count:", responseData.count)
        console.log("responseData.pagination:", responseData.pagination)
        console.log("responseData.pagination?.total:", responseData.pagination?.total)
        console.log("responseData.pagination?.last_page:", responseData.pagination?.last_page)
        console.log("responseData.pagination?.current_page:", responseData.pagination?.current_page)

        // Extract values exactly as they appear in your API response
        const totalItems = responseData.count || 0
        const totalPages = responseData.pagination?.last_page || 0
        const currentPage = responseData.pagination?.current_page || 1
        const dataArray = responseData.data || []

        console.log("=== EXTRACTED VALUES ===")
        console.log("totalItems:", totalItems)
        console.log("totalPages:", totalPages)
        console.log("currentPage:", currentPage)
        console.log("dataArray length:", dataArray.length)

        this.setState({
          data: dataArray,
          totalItems: totalItems,
          totalPages: totalPages,
          page: currentPage,
          isLoading: false,
        })

        console.log("=== STATE AFTER UPDATE ===")
        console.log("this.state.totalItems:", totalItems)
        console.log("this.state.totalPages:", totalPages)
        console.log("this.state.page:", currentPage)
      } else {
        console.log("API response failed or no data")
        this.setState({
          data: [],
          totalItems: 0,
          totalPages: 0,
          isLoading: false,
        })
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      this.setState({
        data: [],
        totalItems: 0,
        totalPages: 0,
        isLoading: false,
      })
      this.showToast("Failed to fetch data", "error")
    }
  }

  toggleRow = (rowId) => {
    this.setState((prev) => ({
      expandedRows: {
        ...prev.expandedRows,
        [rowId]: !prev.expandedRows[rowId],
      },
    }))
  }

  handleSearch = (e) => {
    this.setState({ search: e.target.value }, () => {
      setTimeout(() => this.fetchData(), 500)
    })
  }

  handlePageChange = (newPage) => {
    console.log("=== PAGE CHANGE ===")
    console.log("Changing to page:", newPage)
    console.log("Current totalPages:", this.state.totalPages)

    if (this.props.onPageChange) {
      this.props.onPageChange(newPage)
    } else {
      this.setState({ page: newPage }, this.fetchData)
    }
  }

  handlePerPageChange = (e) => {
    const newPerPage = Number.parseInt(e.target.value)
    if (this.props.onPerPageChange) {
      this.props.onPerPageChange(newPerPage)
    } else {
      this.setState({ perPageItem: newPerPage, page: 1 }, this.fetchData)
    }
  }

  exportToExcel = async (exportType = "xlsx") => {
    const { exportFileName = "report" } = this.props
    try {
      let apiUrl = this.props.api
      apiUrl = apiUrl.replace(/[&?]exportType=[^&]*/g, "")
      const separator = apiUrl.includes("?") ? "&" : "?"
      apiUrl = `${apiUrl}${separator}exportType=${exportType}`
      window.open(apiUrl, "_blank")
    } catch (error) {
      console.error("Export error:", error)
      this.showToast("Failed to export data", "error")
    }
  }

  showToast = (message, severity) => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  render() {
    const { data, isLoading, search, page, perPageItem, totalItems, totalPages, expandedRows } = this.state
    const { columns, nestedKey, title, dateFilter } = this.props

    // Debug render values
    console.log("=== RENDER VALUES ===")
    console.log("totalItems in render:", totalItems)
    console.log("totalPages in render:", totalPages)
    console.log("page in render:", page)
    console.log("perPageItem in render:", perPageItem)

    return (
      <div
        style={{
          backgroundColor: theme.background,
          color: theme.white,
          padding: "24px",
          borderRadius: "8px",
          border: `1px solid ${theme.greybordercolor}`,
        }}
      >
        {/* Header Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "24px",
            paddingBottom: "16px",
            // borderBottom: `2px solid ${theme.btnColor}`,
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <h2
            style={{
              color: theme.white,
              margin: 0,
              fontSize: "24px",
              fontWeight: "600",
            }}
          >
            {title}
          </h2>
          <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>

   {this.props.export && (
  <>
   <Button
      variant="contained"
      onClick={() => this.exportToExcel("pdf")}
      sx={{
        textTransform: "none",
        backgroundColor: theme.redColor,
        color: theme.white,
        "&:hover": { backgroundColor: "#BB0A21" },
        fontWeight: "500",
        height: "40px", // Fixed height to match search
        minWidth: "40px", // Square shape for icon-only
        padding: "0 8px", // Adjust padding for icon
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <img 
        src={pdf} 
        width="16" 
        height="16" 
        alt="PDF"
        style={{
          filter: "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%)"
        }}
      />
    </Button>
    <Button
      variant="contained"
      onClick={() => this.exportToExcel("csv")}
      sx={{
        textTransform: "none",
        backgroundColor: "#FFC857",
        color: theme.black,
        "&:hover": { backgroundColor: "#FFC857" },
        fontWeight: "500",
        height: "40px", // Fixed height to match search
        minWidth: "40px", // Square shape for icon-only
        padding: "0 8px", // Adjust padding for icon
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <img 
        src={csv} 
        width="16" 
        height="16" 
        alt="CSV"
        style={{
          filter: "brightness(0) saturate(100%) invert(8%) sepia(10%) saturate(1475%) hue-rotate(157deg) brightness(95%) contrast(95%)"
        }}
      />
    </Button>
   
  </>
)}
            {dateFilter && dateFilter}
            {this.props.advancedSearch && this.props.advancedSearch}
          </div>
        </div>

        {/* Table Section */}
        <div
          style={{
            overflowX: "auto",
            backgroundColor: theme.pageBgColor,
            // borderRadius: "8px",
            // border: `1px solid ${theme.greybordercolor}`,
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
            }}
          >
            <thead>
              <tr style={{
                backgroundColor: theme.drawerBgColor,
                borderBottom: "1px solid #FFC857"
              }}>
                {nestedKey && (
                  <th
                    style={{
                      padding: "16px 12px",
                      width: "50px",
                      color: theme.white,
                      fontWeight: "600",

                    }}
                  ></th>
                )}
                {columns.map((col) => (
                  <th
                    key={col.key}
                    style={{
                      padding: "16px 12px",
                      textAlign: "left",

                      color: theme.white,
                      fontWeight: "600",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {col.title}
                  </th>
                ))}
                {(this.props.onView || this.props.onEdit || this.props.onDelete) && (
                  <th
                    style={{
                      padding: "16px 12px",
                      textAlign: "center",
                      color: theme.white,
                      fontWeight: "600",
                      fontSize: "13px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td
                    colSpan={
                      columns.length +
                      (nestedKey ? 1 : 0) +
                      (this.props.onView || this.props.onEdit || this.props.onDelete ? 1 : 0)
                    }
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: theme.mutedWhite,
                      fontSize: "16px",
                    }}
                  >

                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td
                    colSpan={
                      columns.length +
                      (nestedKey ? 1 : 0) +
                      (this.props.onView || this.props.onEdit || this.props.onDelete ? 1 : 0)
                    }
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: theme.mutedWhite,
                      fontSize: "16px",
                    }}
                  >
                    No data found
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <React.Fragment key={item.id || index}>
                    <tr
                      style={{
                        backgroundColor: index % 2 === 0 ? theme.background : theme.pageBgColor,
                        transition: "background-color 0.2s ease",
                        "&:hover": { backgroundColor: theme.drawerBgColor },
                      }}
                    >
                      {nestedKey && (
                        <td style={{ padding: "14px 12px", textAlign: "center" }}>
                          {item[nestedKey] && Array.isArray(item[nestedKey]) && item[nestedKey].length > 0 && (
                            <button
                              onClick={() => this.toggleRow(item.id || index)}
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: theme.btnColor,
                                padding: "4px",
                                borderRadius: "4px",
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              {expandedRows[item.id || index] ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
                            </button>
                          )}
                        </td>
                      )}
                      {columns.map((col) => (
                        <td
                          key={col.key}
                          style={{
                            padding: "14px 12px",
                            // borderBottom: `1px solid ${theme.greybordercolor}`,
                            color: theme.white,
                            fontWeight: "400",
                          }}
                        >
                          {col.format ? col.format(item[col.key], item) : item[col.key]}
                        </td>
                      ))}
                      {(this.props.onView || this.props.onEdit || this.props.onDelete) && (
                        <td
                          style={{
                            padding: "14px 12px",
                            // borderBottom: `1px solid ${theme.greybordercolor}`,
                            textAlign: "center",
                          }}
                        >
                          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                            {this.props.onView && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => this.props.onView(item)}
                                className="btn btn-sm me-2 d-flex align-items-center"
                                style={{ backgroundColor: "#00A651", color: "#ffffff" }}
                              >
                                <i className="fa fa-eye me-1" aria-hidden="true"></i> VIEW
                              </Button>
                            )}
                            {this.props.onEdit && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => this.props.onEdit(item)}
                                className="btn btn-sm me-2 d-flex align-items-center"
                                style={{
                                  backgroundColor: ColorScheme.buttonColor,
                                  color: ColorScheme.componentColor,
                                }}
                              >
                                <i className="fa fa-pencil me-1" aria-hidden="true"></i> Edit
                              </Button>
                            )}
                            {this.props.onDelete && (
                              <Button

                                onClick={() => this.props.onDelete(item)}
                                className="btn btn-sm d-flex align-items-center"
                                style={{
                                  backgroundColor: ColorScheme.accentColor,
                                  color: ColorScheme.textColor,
                                }}
                              >
                                <i className="fa fa-trash me-1" aria-hidden="true"></i> Delete
                              </Button>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                    {nestedKey &&
                      expandedRows[item.id || index] &&
                      item[nestedKey]?.map((nestedItem, nestedIndex) => (
                        <tr
                          key={`${item.id || index}-${nestedItem.id || nestedIndex}`}
                          style={{ backgroundColor: theme.drawerBgColor }}
                        >
                          <td></td>
                          {columns.map((col) => (
                            <td
                              key={col.key}
                              style={{
                                padding: "12px 12px 12px 12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.mutedWhite,
                                fontSize: "13px",
                                // fontStyle: "italic",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                {col.nestedFormat && col.nestedKey
                                  ? col.nestedFormat(nestedItem[col.nestedKey], nestedItem)
                                  : nestedItem[col.nestedKey]}
                              </div>
                            </td>
                          ))}
                          {(this.props.onView || this.props.onEdit || this.props.onDelete) && <td></td>}
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "24px",
            paddingTop: "16px",
            borderTop: `1px solid ${theme.greybordercolor}`,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ color: theme.mutedWhite, fontSize: "14px" }}>Show</span>
            <select
              value={perPageItem}
              onChange={this.handlePerPageChange}
              style={{
                padding: "8px 12px",
                backgroundColor: "#041A29",
                color: theme.white,
                border: `1px solid ${theme.greybordercolor}`,
                borderRadius: "4px",
                fontSize: "14px",
              }}
            >
              {[10, 25, 50, 100].map((num) => (
                <option key={num} value={num}>
                  {num} per page
                </option>
              ))}
            </select>
            <span style={{ color: theme.mutedWhite, fontSize: "14px" }}>
              Showing {totalItems > 0 ? (page - 1) * perPageItem + 1 : 0} to {Math.min(page * perPageItem, totalItems)}{" "}
              of {totalItems} entries
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button
              onClick={() => this.handlePageChange(page - 1)}
              disabled={page <= 1}
              style={{
                padding: "8px 16px",
                backgroundColor: page <= 1 ? "#041A29" : theme.btnColor,
                color: page <= 1 ? theme.mutedWhite : theme.blackColor,
                border: "none",
                borderRadius: "4px",
                cursor: page <= 1 ? "not-allowed" : "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Previous
            </button>
            <span
              style={{
                color: theme.white,
                fontSize: "14px",
                padding: "0 16px",
              }}
            >
              Page {page} of {totalPages}
            </span>
            <button
              onClick={() => this.handlePageChange(page + 1)}
              disabled={page >= totalPages}
              style={{
                padding: "8px 16px",
                backgroundColor: page >= totalPages ? "#041A29" : theme.btnColor,
                color: page >= totalPages ? theme.mutedWhite : theme.blackColor,
                border: "none",
                borderRadius: "4px",
                cursor: page >= totalPages ? "not-allowed" : "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Next
            </button>
          </div>
        </div>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={this.handleCloseToast}
        />

        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    )
  }
}

export default redux(ReportTable)
